module.exports = "../images/boat-1.jpg?v=8fefd34";